<template>
  <v-card class="fill-height d-flex flex-column">
    <v-row no-gutters align="center" class="px-2" style="border-bottom: 1px solid #e2e2e2">
      <v-col cols="auto">
        <table-buttons
          :buttons="buttons"
          @increaseTableHeight="increaseTableHeight"
          @decreaseTableHeight="decreaseTableHeight"
          @toggleFilterHeaders="toggleFilterHeaders"
          @toggleFilterBuilder="toggleFilterBuilder"
          @toggleFilterClear="toggleFilterClear"
          @toggleFilterSelected="toggleFilterSelected"
          @clearSelection="clearSelection"
          @selectAllRows="selectAllRows"
          @zoomToSelected="zoomToSelected"
          @openAttachmentsDialog="openAttachmentsDialog"
          @publishLamps="openPublishLampsDialog"
          @createKomadres="openKomadresDialog"
          @sendMessage="openSendMessageDialog"
        >
          <template #layerName-outter>
            <v-row no-gutters class="align-center fill-height" style="min-height: 36px">
              <v-col cols="auto">
                <span>
                  {{ currentLayerName }}
                </span>
              </v-col>
            </v-row>
          </template>
          <template #loadedItemsText-outter>
            <v-row no-gutters class="align-center fill-height">
              <v-col cols="auto">
                <span class="text-caption ml-1 mr-2" style="font-size: 11px;">
                  {{ loadedItemsText }}
                </span>
              </v-col>
            </v-row>
          </template>
          <template #selection>
            <v-badge
              :offset-y="20"
              :offset-x="15"
              bordered
              color="primary"
              :content="badgeNumber"
              overlap
              :value="isAnyFeatureSelected"
            >
              <v-btn v-if="isSelectionActive" icon @click="toogleOffSelection">
                <v-icon class="selection--active background">
                  $selectionActive
                </v-icon>
              </v-btn>
              <dots-menu
                v-else
                :items="selectionMenuItems"
                close-on-content-click
                @single="toggleSelectionByType('single')"
                @multiple="toggleSelectionByType('multiple')"
                @freehand="toggleSelectionByType('freehand')"
              >
                <template #activator="{ on }">
                  <v-btn icon v-on="on" :disabled="isActiveToolNotReplaceable && !isActiveModuleIdentification">
                    <v-icon>
                      $selection
                    </v-icon>
                  </v-btn>
                </template>
              </dots-menu>
            </v-badge>
          </template>
        </table-buttons>
      </v-col>
      <template v-if="!unchangedLayers">
        <slot
          name="additionalTools"
          v-bind="{ ...$data, isAnyFeatureSelected, isTasksVisible, currentLayerSelectedFeatures }"
        >
        </slot>
      </template>
      <v-col cols="auto" v-if="isEditButtonsVisible">
        <table-buttons-edit
          ref="editButtons"
          :is-any-feature-selected="isAnyFeatureSelected"
          :selected-features="currentLayerSelectedFeatures"
          :datasource="currentLayerDataSourceName"
          :geometry-type="currentLayer.geometry_type"
          @refreshTableData="refreshTableData"
          :layer-scope="currentLayer.layer_scope"
          :layer-id="layerId"
        ></table-buttons-edit>
      </v-col>
      <v-spacer></v-spacer>
      <v-col cols="auto" style="max-height: 36px; width: 180px" v-if="!unchangedLayers">
        <div class="mt-2">
          <data-input
            dense
            :data-type="{ name: 'text' }"
            v-model="filters.search_filter"
            prepend-inner-icon="mdi-magnify"
            :placeholder="$i18n.t('default.find')"
            @keyup.enter="handleFilter(false)"
            class="searchInput"
            height="20"
            clearable
          />
        </div>
      </v-col>
      <v-col cols="auto">
        <dots-menu
          font-size="19px"
          :items="tableMenuItems"
          close-on-content-click
          @downloadCsv="downloadFile('csv')"
          @downloadShp="downloadFile('shp')"
          @resetColumnState="resetColumnStateHandler"
        >
        </dots-menu>
      </v-col>
    </v-row>
    <ag-grid-vue
      v-show="isTableVisible"
      style="width: 100%; height: 100%;"
      class="ag-theme-material"
      :gridOptions="gridOptions"
      headerHeight="48"
      :style="highlightedRowColors"
      :context="context"
      :overlayNoRowsTemplate="overlayNoRowsTemplate"
    >
    </ag-grid-vue>
    <main-dialog
      v-if="isMainDialogLoaded && isResetColumnStateDialogVisible"
      :is-visible.sync="isResetColumnStateDialogVisible"
      :title="$i18n.t('dialog.title.resetColumnState')"
      :body="$i18n.t('dialog.body.resetColumnState')"
      agree-text="menu.reset"
      @agree="resetColumnState"
    >
    </main-dialog>
    <main-dialog
      v-if="isMainDialogLoaded && isPublishDialogVisible"
      :is-visible.sync="isPublishDialogVisible"
      :title="$i18n.t('dialog.title.publishLamps')"
      :body="publishLampBody"
      agree-text="menu.publish"
      @agree="publishLamps"
    >
    </main-dialog>
    <main-large-dialog
      ref="filterBuilderDialog"
      v-if="isFilterBuilderLoaded"
      :is-visible.sync="isFilterBuilderVisible"
      :title="$i18n.t('dialog.title.addAdvancedFilter')"
      min-body-height="55vh"
      dialog-width="60%"
      header-shadow
      agree-text="dialog.agreeAdd"
      :is-valid="isFilterBuilderValid"
      @agree="handleFilter"
      @modalClosed="handleCloseExpressionBuilder"
    >
      <template #body>
        <v-col cols="12">
          <expression-builder
            class="expressions"
            ref="builderFilter"
            @update:isValid="isFilterBuilderValid = $event"
            v-model="filters.builder_filter"
            :is-data-source-selectable="false"
            :main-data-source="currentLayerDataSourceName"
            :custom-data-source-attributes="expressionBuilderAttributes"
          />
        </v-col>
      </template>
    </main-large-dialog>
    <attachments-dialog
      v-if="isAttachmentDialogLoaded"
      :is-visible.sync="isAttachmentVisible"
      :features="selectedFeaturesForAttachments"
    ></attachments-dialog>
    <quick-komadres-order
      v-if="isKomadresDialogLoaded"
      :is-visible.sync="isKomadresDialogVisible"
      :layer-id="layerId"
      :selected-features="currentLayerSelectedFeatures"
    />
    <send-message-dialog
      v-if="isSendMessageDialogLoaded"
      :is-visible.sync="isSendMessageDialogVisible"
      :selected-features="currentLayerSelectedFeatures"
    />
    <slot name="dialogs"> </slot>
  </v-card>
</template>

<script>
import { debounce, isEqual } from 'lodash';
import { AgGridVue } from 'ag-grid-vue';
import { get, sync, call } from 'vuex-pathify';

import cells from '@/mixins/cells';
import filters from '@/mixins/filters';
import selectionTable from '@/mixins/selectionTable';
import selectedFeatures from '@/mixins/selectedFeatures';
import fetchAttributesSchemaMixin from '@/mixins/fetchAttributesSchemaMixin';
import prepareAttributesTableMixin from '@/mixins/prepareAttributesTableMixin';

import ExpressionBuilder from '@/components/ExpressionBuilder';
import DotsMenu from '@/components/DotsMenu';
import TableButtons from '@/components/TableButtons';
import TableButtonsEdit from '@/components/TableButtonsEdit';
import TableFloatingFilter from '@/components/TableFloatingFilter';
import DataInput from '@/components/DataInput';

export default {
  name: 'Table',
  mixins: [cells, filters, selectionTable, selectedFeatures, prepareAttributesTableMixin, fetchAttributesSchemaMixin],
  components: {
    DataInput,
    AgGridVue,
    ExpressionBuilder,
    MainLargeDialog: () => import('@/components/MainLargeDialog'),
    DotsMenu,
    AttachmentsDialog: () => import('@/components/AttachmentsDialog'),
    TableButtons,
    TableButtonsEdit,
    // eslint-disable-next-line
    TableFloatingFilter,
    MainDialog: () => import('@/components/MainDialog'),
    QuickKomadresOrder: () => import('@/components/QuickKomadresOrder'),
    SendMessageDialog: () => import('@/components/SendMessageDialog'),
  },
  props: {
    statusesItems: {
      type: Array,
      required: false,
    },
    layersFilters: {
      type: Object,
      default: () => {},
    },
    itemsPerPage: {
      type: Number,
      default: 100,
    },
    isCustomLayer: {
      type: Boolean,
      default: false,
    },
    customLayerData: {
      type: Object,
      default: () => {},
    },
    getFeaturesFunctionName: {
      type: String,
      default: 'getLayerFeatures',
    },
    hasEditButtons: {
      type: Boolean,
      default: false,
    },
    initSorting: {
      type: Array,
    },
    hasGeometry: {
      type: Boolean,
      default: true,
    },
  },
  data: vm => ({
    currentLayerDataSourceObject: {},
    tableMenuItems: [
      {
        name: 'downloadCsv',
      },
      {
        name: 'downloadShp',
      },
      {
        name: 'resetColumnState',
      },
    ],
    isSelectionEventDisabled: false,
    isAttachmentDialogLoaded: false,
    isAttachmentVisible: false,
    totalItems: 0,
    filteredItems: 0,
    isResetColumnStateDialogVisible: false,
    isMainDialogLoaded: false,
    isChangeStatusDialogVisible: false,
    context: {},
    noRowsText: vm.$i18n.t('map.loadingTableData'),
    isPublishDialogVisible: false,
    expressionBuilderAttributes: [],
    unchangedLayers: undefined,
    isKomadresDialogVisible: false,
    isKomadresDialogLoaded: false,
    isSendMessageDialogVisible: false,
    isSendMessageDialogLoaded: false,
  }),
  computed: {
    isActiveToolNotReplaceable: get('tools/isActiveToolNotReplaceable'),
    mapPanelDataFetched: get('map/mapPanelDataFetched'),
    mapRelationDataFetched: get('map/mapRelationDataFetched'),
    activeTool: sync('tools/activeTool'),
    layers: get('layers/layers'),
    vehiclesLayerId: get('admin/modulesMapping@vehicles.layer_id'),
    interval: get('admin/settingsValues@vehicles_module_locations_refresh_interval'),
    tableHeight: sync('table/tableHeight'),
    layersFeatures: get('layers/layersFeatures'),
    projectElements: get('layers/project@layers'),
    projectLayers() {
      return this.$_getFlatGroupsLayers(this.projectElements).layers;
    },
    metadata: get('layers/metadata'),
    currentLayer: get('layers/currentLayer'),
    currentLayerName: get('layers/currentLayer@name'),
    currentLayerDataSourceName: sync('layers/currentLayer@data_source_name'),
    geometryAttributeName: get('layers/currentLayerMetadata@attributes_schema.geometry_name'),
    idPropertyName: get('layers/metadata@:currentLayerDataSourceName.attributes_schema.id_name'),
    isCopyButtonActive: get('edit/isCopyButtonActive'),
    isSelectionActive: sync('tools/toolStatus@isSelectionActive'),
    relationValuesMapping: get('layers/relationValuesMapping'),
    isUseQualifiedNames: get('layers/metadata@:currentLayerDataSourceName.attributes_use_datasource_qualified_names'),
    cutoffResult: get('locks/cutoffResult'),
    dataSourceMetadata: get('layers/metadata@:currentLayerDataSourceName'),
    app_kind: get('admin/appKind'),
    streetLampsUnpublishedLayerId: get('admin/modulesMapping@zdm_data.layers.street_lamp_unpublished'),
    streetLampsLayerId: get('admin/modulesMapping@zdm_data.layers.street_lamp'),
    streetLampsIdPropName: get('layers/metadata@zdm_data_street_lamp.attributes_schema.id_name'),
    polesLayerGeomId: get('admin/modulesMapping@zdm_data.layers.pole'),
    pickArmsLayerGeomId: get('admin/modulesMapping@zdm_data.layers.pick_arm'),
    lightHeadsLayerGeomId: get('admin/modulesMapping@zdm_data.layers.head'),
    zdmStreetLampDataSourceName: get('admin/modulesMapping@zdm_data.datasources.street_lamp.datasource'),
    cableDataSourceName: get('admin/modulesMapping@zdm_data.datasources.cable.datasource'),
    attachmentsDataSourceName: get('admin/modulesMapping@documentation.attachment_datasource_name'),
    vehiclesDataSourceName: get('admin/modulesMapping@vehicles.datasource_name'),
    zdmReadonlyDatasources: get('admin/modulesMapping@zdm_data.read_only_datasources'),
    isModifySnappingActive: get('edit/isModifySnappingActive'),
    komadresSelectedDataSource: get('admin/modulesMapping@komadres_orders.komadres_orders_datasource'),
    isKomadresSettingsEnabled: get('admin/settingsValues@komadres_orders_module_enabled'),
    isKomadresModuleEnabled: get('admin/additionalModules@KOMADRES_ORDERS.enabled'),
    hasKomadresPermissions() {
      return this.$store.get('users/toolsPermissions')['KOMADRES_ORDERS'].main_value > 0;
    },
    isKomadresOrderVisible() {
      return (
        this.isKomadresSettingsEnabled &&
        this.isKomadresModuleEnabled &&
        this.hasKomadresPermissions &&
        this.hasGeometry &&
        this.currentLayerDataSourceName !== this.komadresSelectedDataSource
      );
    },
    isSendMessageSettingsEnabled: get('admin/settingsValues@send_message_module_enabled'),
    isSendMessageModuleEnabled: get('admin/additionalModules@SEND_MESSAGE_MODULE.enabled'),
    hasSendMessagePermissions() {
      return this.$store.get('users/toolsPermissions')['SEND_MESSAGE_MODULE'].main_value > 0;
    },
    isSendMessageVisible() {
      return (
        this.isSendMessageSettingsEnabled &&
        this.isSendMessageModuleEnabled &&
        this.hasSendMessagePermissions &&
        this.hasGeometry
      );
    },
    attachmentsAndCommentsPermission() {
      return this.permissions[this.currentLayer.id].attachments_and_comments_value;
    },
    lampSubfeaturesLayersIds() {
      return [this.polesLayerGeomId, this.pickArmsLayerGeomId, this.lightHeadsLayerGeomId];
    },
    isActiveModuleIdentification() {
      return this.activeTool === 'moduleIdentification';
    },
    isVehiclesLayer() {
      return this.layerId == this.vehiclesLayerId;
    },
    isTasksVisible() {
      return !this.isVehiclesLayer;
    },
    isZdmGeomLayers() {
      return this.zdmReadonlyDatasources.includes(this.currentLayerDataSourceName);
    },
    isEditButtonsVisible() {
      return (
        this.hasEditPermissions &&
        this.hasEditButtons &&
        !this.isVehiclesLayer &&
        !this.isZdmGeomLayers &&
        !this.unchangedLayers
      );
    },
    isTableVisible() {
      return this.tableHeight > 0;
    },
    isCutoffLayer() {
      return this.$route.name === 'cutoffLayerTable';
    },
    layerId() {
      return this.isCustomLayer ? this.customLayerData.layerId : this.$route.params.lid;
    },
    badgeNumber() {
      return this.isAnyFeatureSelected ? this.currentLayerSelectedFeatures.length : 0;
    },
    hasDataSourceQualifiedNames() {
      return this.dataSourceMetadata?.attributes_use_datasource_qualified_names;
    },
    highlightedRowColors() {
      return {
        '--border-color': this.$_colors.error,
        '--background-color': `${this.$_colors.error}1f`,
      };
    },
    overlayNoRowsTemplate() {
      return `<span class="ag-overlay-loading-center">${this.noRowsText}</span>`;
    },
    permissions: get('users/layersPermissions'),
    hasEditPermissions() {
      return this.permissions[this.layerId]?.main_value === 2;
    },
    gridOptions() {
      return {
        rowData: null,
        columnDefs: null,
        pagination: false,
        rowSelection: false,
        rowDeselection: true,
        onRowClicked: this.onRowClicked,
        onSelectionChanged: this.onSelectionChanged,
        onGridReady: this.onGridReady,
        suppressDragLeaveHidesColumns: true,
        onColumnMoved: e => {
          this.saveColumnState(e.columnApi.getColumnState());
        },
        onColumnResized: e => {
          this.saveColumnState(e.columnApi.getColumnState());
        },
        getRowNodeId: data => {
          return data?.[this.idPropertyName];
        },
        rowClassRules: {
          'ag-row-highlighted': params => {
            return (this.currentLayerHighlitedFeatures || []).includes(params?.node?.id);
          },
        },
        localeText: {
          loadingOoo: this.$i18n.t('map.loadingTableData'),
        },
        defaultColDef: this.defaultColDef,
        components: {
          StatusCell: this.getStatusCell(),
          ColorSelectCell: this.getColorSelectCell(),
        },
        frameworkComponents: {
          TableFloatingFilter: 'TableFloatingFilter',
        },
        rowModelType: 'infinite',
        paginationPageSize: this.itemsPerPage,
        cacheBlockSize: this.itemsPerPage,
        maxBlocksInCache: 10,
        cacheOverflowSize: 2,
        // infiniteInitialRowCount: 5,
      };
    },
    isIncreaseTableHeightButtonDisabled() {
      return this.tableHeight === 3;
    },
    isDecreaseTableHeightButtonDisabled() {
      return this.tableHeight === 0;
    },
    isUnpublishedLampLayer() {
      return this.layerId == this.streetLampsUnpublishedLayerId;
    },
    isCableOrLampDatasource() {
      return (
        this.currentLayerDataSourceName === this.cableDataSourceName ||
        this.currentLayerDataSourceName === this.zdmStreetLampDataSourceName
      );
    },
    nonAttachmentsDataSources() {
      return [this.attachmentsDataSourceName, this.vehiclesDataSourceName];
    },
    hasAttachments() {
      return !this.nonAttachmentsDataSources.includes(this.currentLayerDataSourceName);
    },
    selectionMenuItems() {
      return [
        {
          name: 'single',
        },
        ...(this.hasGeometry
          ? [
              {
                name: 'multiple',
              },
              {
                name: 'freehand',
              },
            ]
          : []),
      ];
    },
    buttons() {
      return [
        {
          name: 'increaseTableHeight',
          icon: 'mdi-chevron-up',
          disabled: this.isIncreaseTableHeightButtonDisabled,
          tooltip: this.isIncreaseTableHeightButtonDisabled
            ? this.$i18n.t('button.increaseTableDisabled')
            : this.$i18n.t('button.increaseTable'),
          buttonSize: 'small',
        },
        {
          name: 'decreaseTableHeight',
          icon: 'mdi-chevron-down',
          disabled: this.isDecreaseTableHeightButtonDisabled,
          tooltip: this.isDecreaseTableHeightButtonDisabled
            ? this.$i18n.t('button.decreaseTableDisabled')
            : this.$i18n.t('button.decreaseTable'),
          classes: 'mr-3',
          buttonSize: 'small',
        },
        {
          name: 'layerName',
        },
        {
          name: 'loadedItemsText',
        },
        ...(!this.unchangedLayers
          ? [
              {
                name: 'toggleFilterHeaders',
                icon: 'mdi-filter-variant',
                tooltip: this.isModifySnappingActive
                  ? this.$i18n.t('button.toManageFilters', { reason: this.$i18n.t('button.turnOffEditing') })
                  : this.$i18n.t('button.columnFilter'),
                fontSize: '19px',
                hasState: true,
                isActive: Boolean(this.isHeadersFilterActive),
                disabled: this.isModifySnappingActive,
              },
              {
                name: 'toggleFilterBuilder',
                icon: this.isBuilderFilterActive ? '$filteractive' : '$filter',
                tooltip: this.isModifySnappingActive
                  ? this.$i18n.t('button.toManageFilters', { reason: this.$i18n.t('button.turnOffEditing') })
                  : this.$i18n.t('button.advancedFilter'),
                hasState: true,
                isActive: Boolean(this.isBuilderFilterActive),
                disabled: this.isModifySnappingActive,
              },
              {
                name: 'toggleFilterClear',
                icon: '$unfilter',
                tooltip: this.isModifySnappingActive
                  ? this.$i18n.t('button.toManageFilters', { reason: this.$i18n.t('button.turnOffEditing') })
                  : this.isFilterActive
                  ? this.$i18n.t('button.clearAllFilters')
                  : this.$i18n.t('button.noFilterToRemove'),
                disabled: !this.isFilterActive || this.isModifySnappingActive,
              },
              {
                name: 'selection',
                tooltip: this.isSelectionActive
                  ? this.$i18n.t('button.selectionOff')
                  : this.isActiveToolNotReplaceable
                  ? this.$i18n.t('button.oneToolActive')
                  : this.$i18n.t('button.selectOnMapOrTable'),
                hasState: true,
                isActive: this.isSelectionActive,
              },
              {
                name: 'clearSelection',
                icon: '$unselection',
                tooltip: this.isAnyFeatureSelected
                  ? this.$i18n.t('button.clearSelection')
                  : this.$i18n.t('button.noObjectsSelected', { suffix: '' }),
                disabled: !this.isAnyFeatureSelected,
              },
              {
                name: 'toggleFilterSelected',
                icon: 'mdi-table-arrow-up',
                tooltip: !this.isAnyFeatureSelected
                  ? this.$i18n.t('button.noObjectsSelected', { suffix: '' })
                  : this.isFilterSelectedActive
                  ? this.$i18n.t('button.backToList')
                  : this.$i18n.t('button.toggleFilterSelected'),
                disabled: !this.isAnyFeatureSelected,
                isActive: this.isFilterSelectedActive,
                fontSize: '19px',
              },
              {
                name: 'selectAllRows',
                icon: 'mdi-checkbox-multiple-marked',
                tooltip: this.isAllRowsSelected ? '' : this.$i18n.t('button.selectAll'),
                disabled: this.isAllRowsSelected,
                fontSize: '19px',
              },
              ...(this.hasGeometry
                ? [
                    {
                      name: 'zoomToSelected',
                      icon: 'mdi-magnify',
                      tooltip: this.isAnyFeatureSelected
                        ? this.$i18n.t('button.zoomToSelected')
                        : this.$i18n.t('button.noObjectsSelected', { suffix: this.$i18n.t('button.noFeaturesToZoom') }),
                      fontSize: '19px',
                      disabled: !this.isAnyFeatureSelected,
                    },
                  ]
                : []),
              ...(this.attachmentsAndCommentsPermission > 0 && this.hasAttachments
                ? [
                    {
                      name: 'openAttachmentsDialog',
                      icon: 'mdi-paperclip',
                      tooltip: this.isAnyFeatureSelected
                        ? this.$i18n.t('button.addAttachments')
                        : this.$i18n.t('button.toAddAttachemnts', {
                            suffix: this.$i18n.t('button.atLeastOneSelected'),
                          }),
                      fontSize: '19px',
                      disabled: !this.isAnyFeatureSelected,
                    },
                  ]
                : []),
              ...(this.isUnpublishedLampLayer
                ? [
                    {
                      name: 'publishLamps',
                      icon: 'mdi-publish',
                      tooltip: this.isAnyFeatureSelected
                        ? this.$i18n.t('button.publishLamps')
                        : this.$i18n.t('button.toPublishLamps', { suffix: this.$i18n.t('button.atLeastOneSelected') }),
                      fontSize: '19px',
                      disabled: !this.isAnyFeatureSelected,
                    },
                  ]
                : []),
              ...(this.isKomadresOrderVisible
                ? [
                    {
                      name: 'createKomadres',
                      icon: '$createKomadresOrder',
                      color: 'font',
                      tooltip: this.isAnyFeatureSelected
                        ? this.$i18n.t('button.addKomadresOrder')
                        : this.$i18n.t('button.toCreateKomadresOrder', {
                            suffix: this.$i18n.t('button.atLeastOneSelected'),
                          }),
                      fontSize: '19px',
                      disabled: !this.isAnyFeatureSelected,
                    },
                  ]
                : []),
              ...(this.isSendMessageVisible
                ? [
                    {
                      name: 'sendMessage',
                      icon: 'mdi-email',
                      tooltip: this.isAnyFeatureSelected
                        ? this.$i18n.t('button.sendMessage')
                        : this.$i18n.t('button.toSendMessage', {
                            suffix: this.$i18n.t('button.atLeastOneSelected'),
                          }),
                      fontSize: '19px',
                      disabled: !this.isAnyFeatureSelected,
                    },
                  ]
                : []),
            ]
          : []),
      ];
    },
    selectedFeaturesForAttachments() {
      return (this.currentLayerSelectedFeatures || []).map(r => ({
        datasource_name: this.currentLayerDataSourceName,
        id: r,
      }));
    },
    loadedItemsText() {
      return `(${this.filteredItems}/${this.totalItems})`;
    },
    publishLampBody() {
      return this.$i18n.t('dialog.body.publishLamps', {
        number: this.currentLayerSelectedFeatures.length,
        lamps: this.$i18n.tc('default.lamps', this.currentLayerSelectedFeatures.length),
      });
    },
  },
  watch: {
    currentLayerSelectedFeatures(nV, oV) {
      this.highlightSelectedRows(nV);
      if (this.isFilterSelectedActive) {
        if (isEqual(oV, nV)) {
          return;
        } else if (!oV || !nV) {
          this.toggleFilterSelected();
          return;
        }
        this.handleFilter();
      }
    },
    currentLayerHighlitedFeatures(nV, oV) {
      this.gridOptions.api.redrawRows({ rowNodes: this.getRowsToUpdate(nV || oV) });
    },
    mapPanelDataFetched: {
      immediate: true,
      handler(nV) {
        if (nV && this.unchangedLayers) {
          this.onLayerChanged(this.unchangedLayers.oV, this.unchangedLayers.nV);
        }
      },
    },
    mapRelationDataFetched: {
      immediate: true,
      handler(nV) {
        if (nV && this.unchangedLayers) {
          this.onLayerChanged(this.unchangedLayers.oV, this.unchangedLayers.nV);
        }
      },
    },
  },
  methods: {
    calculateFieldsNonTopo: call('edit/calculateFields'),
    // getDataSourceForm: call('layers/getDataSourceForm'),

    getLayerFeatures: call('layers/getLayerFeatures'),
    exportLayerFeatures: call('layers/exportLayerFeatures'),
    // getRelationValuesMapping: call('layers/getRelationValuesMapping'),
    resetColumnStateHandler() {
      this.isMainDialogLoaded = true;
      this.isResetColumnStateDialogVisible = true;
    },
    resetColumnState() {
      const currentState = JSON.parse(localStorage.getItem('columnsState')) || {};
      const stateCopy = { ...currentState };
      delete stateCopy[this.layerId];
      localStorage.setItem('columnsState', JSON.stringify(stateCopy));
      this.gridOptions.api.setColumnDefs([]);
      setTimeout(() => {
        const columnsDefs = this.getColumnDefs(
          undefined,
          this.currentLayer.form_schema.elements,
          this.attributesMetadata
        );
        this.gridOptions.api.setColumnDefs(columnsDefs);
      }, 0);
      this.isResetColumnStateDialogVisible = false;
    },
    saveColumnState(columns) {
      const currentState = JSON.parse(localStorage.getItem('columnsState')) || {};
      const columnsState = columns.reduce((total, { colId, width }, index) => {
        return {
          ...total,
          [colId]: {
            width,
            index,
          },
        };
      }, {});
      localStorage.setItem('columnsState', JSON.stringify({ ...currentState, [this.layerId]: columnsState }));
    },
    downloadFile(format) {
      const features_filter = this.isAnyFeatureSelected
        ? {
            $IN: {
              [this.isUseQualifiedNames
                ? this.idPropertyName
                : `${this.currentLayerDataSourceName}.${this.idPropertyName}`]: this.currentLayerSelectedFeatures,
            },
          }
        : this.handleGetFilter();
      this.exportLayerFeatures({ layer_id: this.layerId, format, features_filter });
    },
    getZdmLampParentFeatureId(properties) {
      const key = Object.keys(properties).find(key => /street_lamp_id/.test(key));
      return properties[key];
    },
    onRowClicked(e) {
      if (this.isSelectionActive || !e || !e.node || (!e.node.id && e.node.id !== 0)) {
        return;
      }
      if (this.lampSubfeaturesLayersIds.includes(+this.layerId)) {
        this.$router.push({
          name: 'layerFeature',
          params: {
            lid: this.layerId,
            fid: e.node?.id,
          },
          query: {
            lamp_id: this.getZdmLampParentFeatureId(e.data),
            id: e.node?.id,
            type: this.currentLayerDataSourceName.match(/(?<=zdm_data_).*/)[0],
          },
        });
      } else {
        this.$router.push({
          name: this.isCustomLayer ? this.customLayerData.routeName : 'layerFeature',
          params: {
            lid: this.isCustomLayer && this.customLayerData.routeName !== 'layerFeature' ? '' : this.layerId,
            fid: e.node?.id,
          },
        });
      }
    },
    getRowsToUpdate(ids = this.currentLayerHighlitedFeatures) {
      const { api } = this.gridOptions;
      return (ids || [])
        .map(id => {
          return api.getRowNode(id);
        })
        .filter(row => row); // highlited rows may not be currently rendered in table
    },
    onBodyScroll() {
      this.highlightSelectedRows(this.currentLayerSelectedFeatures);
      this.gridOptions.api.redrawRows({ rowNodes: this.getRowsToUpdate() });
    },
    increaseTableHeight() {
      if (this.tableHeight < 3) {
        this.tableHeight++;
      }
    },
    decreaseTableHeight() {
      if (this.tableHeight > 0) {
        this.tableHeight--;
      }
    },
    clearFiltersOnLayerChanged() {
      if (this.isFilterBuilderValid) {
        this.$refs.builderFilter.clearAllFilteres();
      }
    },
    setFiltersOnLayerChanged() {
      this.filters =
        this.layersFilters[this.layerId] && this.layersFilters[this.layerId].filters
          ? JSON.parse(JSON.stringify(this.layersFilters[this.layerId].filters))
          : {
              builder_filter: undefined,
              headers_filter: {},
              search_filter: '',
              navbar_filter: {},
              sidebar_filter: {},
            };
      if (!this.filters.builder_filter) {
        this.clearFiltersOnLayerChanged();
      }
    },
    onGridReady() {
      // Workaround for closing the table from another component
      if (!this.gridOptions || !this.gridOptions.api) {
        return;
      }
      this.gridOptions.api.addEventListener('bodyScroll', this.onBodyScroll);
    },
    async onLayerChanged(oV, nV) {
      const withUnchangedLayers = JSON.parse(JSON.stringify(this.unchangedLayers ? true : false));
      if (oV?.id || oV?.id === 0) {
        this.$store.set('map/DELETE_SELECTED_FEATURES!', {
          type: 'selectedFeatures',
          features: {
            [oV.id]: [],
          },
        });
      }
      this.$refs?.editButtons?.tableLayerChanged(oV, nV);
      this.setFiltersOnLayerChanged();
      if (this.gridOptions && this.gridOptions.api) {
        this.gridOptions.api.showLoadingOverlay();
      }
      this.toogleOffSelection();
      if (this.isAnyFeatureSelected) {
        this.clearSelection();
      }
      if (this.mapPanelDataFetched) {
        const relations = this.getRelationalValues(
          this.currentLayerForm,
          this.metadata[this.currentLayerDataSourceName].attributes_schema.attributes
        );
        if (relations.length > 0 && !this.mapRelationDataFetched) {
          this.unchangedLayers = { oV, nV };
          return;
        } else {
          this.unchangedLayers = undefined;
        }
      } else {
        this.unchangedLayers = { oV, nV };
        return;
      }
      // Workaround for closing the table from another component
      if (!this.currentLayer) {
        return;
      }
      if (withUnchangedLayers) {
        this.$root.$emit('tableDataFetched');
      }
      this.setColumnDefs();
      this.expressionBuilderAttributes = this.getExpressionBuilderAttributes(
        this.currentLayer.form_schema.elements,
        this.attributesMetadata
      );
      this.initTableDatasource();
      if (!this.gridOptions.defaultColDef.floatingFilter) {
        this.toggleFilterHeaders();
      }
      if (this.$refs.form) {
        this.$refs.form.resetValidation();
      }
      if (this.isCustomLayer) {
        this.$root.$emit(this.customLayerData.eventName, true);
      }
      this.isHeadersFilterActive = this.getHeadersFilterActive();
      this.isBuilderFilterActive = this.getBuilderFilterExpression();
      this.isSearchFilterActive = this.getSearchFilterActive();
      this.isFilterActive = this.getFilterActive();
      if (this.gridOptions.defaultColDef.floatingFilter) {
        this.toggleFilterHeaders();
      }
      if (this.initSorting) {
        const sortModel = this.initSorting.map(element => {
          const { attribute, sort } = element;
          return { colId: attribute, sort };
        });
        this.gridOptions.api.setSortModel(sortModel);
      }
      if (oV && this.layersFilters[oV?.id]) {
        this.$root.$emit('filterProjectLayer', oV.id, this.layersFilters[oV.id].filterExpression);
      }
    },
    showNoRowsOverlay(text) {
      this.noRowsText = text;
      setTimeout(() => {
        this.gridOptions.api.showNoRowsOverlay();
      }, 0);
    },
    async fetchRows(params, page, sorting, features_filter) {
      return await this[this.getFeaturesFunctionName]({
        layer_id: this.layerId,
        sorting:
          sorting ||
          params.sortModel.map(column => ({
            attribute_name: column.colId,
            direction: column.sort,
          })),
        features_filter,
        params: {
          limit: this.itemsPerPage,
          with_total_count: true,
          with_count: true,
          with_geometry: false,
          with_total_count_without_filter: true,
          page,
        },
      });
    },
    initTableDatasource({ sorting, clearSelection = true, features_filter = this.handleGetFilter() } = {}) {
      const self = this;
      this.totalItems = 0;
      this.filteredItems = 0;
      const dataSource = {
        rowCount: null, // behave as infinite scroll
        async getRows(params) {
          const page = params.startRow / self.itemsPerPage;
          // page is equal to 0 on table init, layer change, after filtering or sorting and after refreshing (even when table were scrolled to the bottom)
          if (page === 0) {
            self.gridOptions.api.showLoadingOverlay();
            if (!self.isRefreshing && !self.isCopyButtonActive && clearSelection) {
              self.clearSelection();
            }
          } else {
            self.showNoRowsOverlay(self.$i18n.t('map.loadingTableData'));
          }
          const r = await self.fetchRows(params, page, sorting, features_filter);
          if (self.currentLayerSelectedFeatures?.length > 0 && page === 0) {
            const rr = await self[self.getFeaturesFunctionName]({
              layer_id: self.layerId,
              features_filter,
              params: {
                ids_only: true,
                with_geometry: false,
              },
            });
            const filteredIds = rr.data.data.ids;
            const filteredSelectedIds = JSON.parse(JSON.stringify(self.currentLayerSelectedFeatures || [])).filter(id =>
              filteredIds.includes(id)
            );
            self.currentLayerSelectedFeatures = filteredSelectedIds;
          }
          self.gridOptions.api.hideOverlay();
          const { total_features_count_without_filter, total_features_count } = r.data.data;
          // layer is empty or filters returned no results
          if (total_features_count === 0) {
            self.showNoRowsOverlay(self.$i18n.t('map.noData'));
          }
          self.filteredItems = total_features_count;
          self.totalItems = total_features_count_without_filter;
          params.successCallback(
            r.data.data.features.features.map(feature => ({
              ...feature.properties,
              [self.idPropertyName]: self.$_hasAnyValue(feature.id) ? feature.id : feature.properties.id,
            })),
            r.data.data.total_features_count
          );
          self.isRefreshing = false;
          self.$root.$emit('tableDataRowsFetched');
        },
      };
      this.gridOptions.api.setDatasource(dataSource);
    },
    sortColumns(columnState, mappedElements) {
      return columnState
        ? mappedElements.sort((a, b) => {
            if (!columnState[a.field]) {
              return 1;
            }
            if (!columnState[b.field]) {
              return -1;
            }
            return columnState[a.field]?.index - columnState[b.field]?.index;
          })
        : mappedElements;
    },
    getColumnState() {
      const columnsState = JSON.parse(localStorage.getItem('columnsState'));
      return columnsState?.[this.layerId];
    },
    setColumnDefs(defs = this.getSortedColumDefs()) {
      /*
        this.gridOptions.api.setColumnDefs([]) - resets columns state and properties with same name eg. id will not cause
        issues while sorting (repetetive names are suffixed with _1)
        https://github.com/ag-grid/ag-grid/issues/2889#issuecomment-555816473
      */
      this.gridOptions.api.setColumnDefs([]);
      this.gridOptions.api.setColumnDefs(defs);
    },

    openAttachmentsDialog() {
      this.isAttachmentDialogLoaded = true;
      this.isAttachmentVisible = true;
    },
    openKomadresDialog() {
      this.isKomadresDialogLoaded = true;
      this.isKomadresDialogVisible = true;
    },
    openSendMessageDialog() {
      this.isSendMessageDialogLoaded = true;
      this.isSendMessageDialogVisible = true;
    },
    refreshTableData() {
      this.isRefreshing = true;
      this.gridOptions.api.infiniteRowModel.refreshCache();
    },
    // TODO - 🤮 do reaktoryzacji
    refreshVehicles() {
      this.vehiclesTimeout = setTimeout(() => {
        this.refreshVehicles();
      }, (this.interval || 5) * 1000);
    },
    onProjectFetch() {
      if (this.$route.params.lid) {
        this.toogleOffSelection();
        if (this.isAnyFeatureSelected) {
          this.clearSelection();
        }
        this.$off();
      }
    },
    beforeDestroy() {
      this.toogleOffSelection(false);
      if (this.isAnyFeatureSelected) {
        this.clearSelection();
      }
      this.$off();
    },
    openPublishLampsDialog() {
      this.isMainDialogLoaded = true;
      this.isPublishDialogVisible = true;
    },
    refreshLayersAndTable(layers) {
      this.$root.$emit('refreshTableData');
      this.$root.$emit(
        'refreshMvtSources',
        layers.map(layer => ({ id: layer, group: 'layers' })),
        true
      );
    },
    async publishLamps(ids = this.currentLayerSelectedFeatures) {
      try {
        await this.calculateFieldsNonTopo({
          calculator_expressions: [
            {
              FIXED: {
                [`${this.currentLayerDataSourceName}.status`]: {
                  value: this.$i18n.t('sidebar.zdmLamp.published'),
                },
              },
            },
          ],
          features_filter: {
            $IN: {
              [this.streetLampsIdPropName]: ids,
            },
          },
          dataSource: this.currentLayerDataSourceName,
        });
        this.refreshLayersAndTable([this.streetLampsLayerId, this.streetLampsUnpublishedLayerId]);
        this.isPublishDialogVisible = false;
      } catch (error) {
        console.log('  error', error);
      }
    },
  },
  // https://www.ag-grid.com/vue-grid/component-communication/
  beforeMount() {
    this.context = {
      contextParent: this,
    };
  },
  mounted() {
    this.$watch(
      'currentLayer',
      (nV, oV) => {
        if (!nV) {
          return;
        }
        this.onLayerChanged(oV, nV);
      },
      {
        immediate: true,
      }
    );
    this.onBodyScroll = debounce(this.onBodyScroll, 150);
    this.$root.$off('setAdditionalFilters');
    this.$root.$off('setSidebarFilters');
    this.$root.$off('refreshTableData');
    this.$root.$on('setAdditionalFilters', this.setAdditionalFilters);
    this.$root.$on('setSidebarFilters', this.setSidebarFilters);
    this.$root.$on('refreshTableData', this.refreshTableData);
    this.$root.$on('fetchProject', this.onProjectFetch);
    this.$once('hook:beforeDestroy', this.beforeDestroy);
    if (this.isVehiclesLayer) {
      this.refreshVehicles();
    }
  },
};
</script>

<style lang="scss" scoped>
@import '../../node_modules/ag-grid-community/dist/styles/ag-grid.css';
@import '../../node_modules/ag-grid-community/dist/styles/ag-theme-material.css';

.background {
  background-color: #e8f0fe !important;
  color: map-get($colors, 'link') !important;
  border-radius: 2px;
}

.selection--active {
  width: 27px !important;
  svg {
    width: 26px;
  }
}

::v-deep {
  .searchInput {
    .v-input__slot {
      min-height: 0px !important;
      padding: 0 4px !important;
    }
    .v-input__append-inner {
      margin: 0 !important;
    }
    .v-input__prepend-inner {
      margin: 0 !important;
      .v-input__icon {
        .v-icon {
          font-size: 16px;
          padding-bottom: 3px;
        }
      }
    }
    .v-label {
      font-size: 12px;
      top: 0 !important;
    }
    .v-text-field__slot input {
      font-size: 12px !important;
      padding-bottom: 3px !important;
    }
  }
  .v-input__icon .v-icon {
    font-size: 18px;
  }
  .expressions .v-text-field__slot input {
    font-size: 14px;
  }
  .v-text-field__slot input {
    font-size: 12px;
  }
  .ag-header-cell-text {
    text-align: center;
    width: 100%;
  }
  .ag-overlay-no-rows-center {
    padding-top: 20px;
  }
  .ag-cell-focus {
    border: none !important;
  }
  .ag-center-cols-container {
    min-width: 100%;
  }
  .ag-row-selected {
    background-color: rgba(250, 255, 0, 0.22);
  }
  .ag-cell div {
    overflow: hidden;
    text-overflow: ellipsis;
  }
  .ag-row-highlighted {
    border: 2px solid var(--border-color);
  }
  .ag-row-highlighted:not(.ag-row-selected) {
    background-color: var(--background-color);
  }
}
</style>
